import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/pages/Index'),
      redirect: '/login',
      children: [
        {
          name: 'Login',
          path: '/login',
          component: () => import('@/views/pages/Login'),
        },
        {
          name: 'Register',
          path: '/register',
          component: () => import('@/views/pages/Register'),
        },
        {
          path: '/reset-password',
          name: 'reset-password',
          component: () => import('@/views/pages/ForgotPassword'),
        },
        {
          path: '/reset-password/:token/:email',
          name: 'reset-password-form',
          component: () => import('@/views/pages/ResetPasswordForm'),
        },
      ],
    },
    {
      path: '',
      component: () => import('@/views/dashboard/Index'),
      meta: { requiresAuth: true },
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: 'dashboard',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Pages
        {
          name: 'UsersList',
          path: 'users',
          component: () => import('@/views/dashboard/pages/admin/users/index'),
        },
        {
          name: 'CompaniesList',
          path: 'companies',
          component: () => import('@/views/dashboard/pages/admin/companies/Index'),
        },
        {
          name: 'AddUser',
          path: 'user/add',
          component: () => import('@/views/dashboard/pages/admin/users/add'),
        },
        {
          name: 'EditUser',
          path: 'user/:id/edit',
          component: () => import('@/views/dashboard/pages/admin/users/edit'),
        },
        {
          name: 'Portals',
          path: 'portals',
          component: () => import('@/views/dashboard/pages/admin/portals/Index'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    let userState = store.state.user.isLoggedIn
    if (!userState) {
      next(
        {
          path: '/login',
        })
    } else {
      next()
    }
  } else {
    next()
  }
})

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if(response.status == 401 ) {
      // router.push('/login')
    }
  });
})
export default router
